import { Comment, ThreadUserHeader } from "@/pb/scout/message/v1/message_pb";
import { CommentListItem } from "@/components/Pages/Scout/Messages/CommentListContainer/CommentList/types";
import { unixTimeMSToDateStr } from "@/helpers/date-helper";
import { CommentItem } from "@/components/Pages/Scout/Messages/CommentListContainer/CommentList/Comment/types";
import { UserItem } from "@/components/Pages/Scout/Messages/CommentListContainer/UserHeader/types";
import { CommentMemberType } from "@/pb/scout/message/v1/message_pb";

export const convertCommentsToCommentListItems = (
  comments: Comment[]
): CommentListItem[] => {
  const commentListItems: CommentListItem[] = [];
  comments.forEach((comment: Comment) => {
    const dateStr = unixTimeMSToDateStr(comment.getSentAtMs());
    const commentItem: CommentItem = {
      id: comment.getId(),
      memberType: comment.getMemberType(),
      text: comment.getText(),
      timestampMS: comment.getSentAtMs(),
      userReadAtMS: comment.hasUserReadAtMs()
        ? comment.getUserReadAtMs()
        : undefined,
      alreadySent: comment.getAlreadySent()
    };
    const commentListItem = commentListItems.find(
      (item: CommentListItem) => item.dateStr === dateStr
    );
    if (commentListItem) {
      commentListItem.comments.unshift(commentItem);
    } else {
      commentListItems.unshift({
        dateStr,
        comments: [commentItem]
      });
    }
  });
  return commentListItems;
};

export const convertThreadUserHeaderToUserItem = (
  threadUser: ThreadUserHeader
): UserItem => {
  const lastName = threadUser.hasLastName()
    ? threadUser.getLastName()
    : undefined;
  const firstName = threadUser.hasFirstName()
    ? threadUser.getFirstName()
    : undefined;

  return {
    id: threadUser.getId(),
    firstName: firstName,
    lastName: lastName,
    uniqueId: threadUser.getUniqueId(),
    grade: threadUser.getGrade(),
    graduateYear: threadUser.getGraduateYear(),
    universityName: threadUser.getUniversityName()
  };
};

type CommentRow = {
  id?: number;
  memberType: number;
  text: string;
  timestampMS: number;
};

type ConvertedMessage = {
  dateStr: string;
  comments: CommentRow[];
};

export const findLastUserCommentId = (data: ConvertedMessage[]) => {
  const initialComment: CommentRow = {
    timestampMS: -Infinity,
    memberType: CommentMemberType.COMMENT_MEMBER_TYPE_USER,
    text: ""
  };

  const lastUserComment = data
    .flatMap(item => item.comments)
    .filter(
      comment =>
        comment.memberType === CommentMemberType.COMMENT_MEMBER_TYPE_USER
    )
    .reduce(
      (prev, curr) => (prev.timestampMS > curr.timestampMS ? prev : curr),
      initialComment
    );

  return lastUserComment ? lastUserComment.id : undefined;
};

export const getLastMessageItem = (
  messageThreadId: number,
  commentList: CommentListItem[]
) => {
  if (!messageThreadId) {
    return undefined;
  }
  const lastCommentListItem = commentList.slice(-1)[0];
  const lastComment = lastCommentListItem?.comments.slice(-1)[0];

  if (!lastComment) {
    return undefined;
  }

  return {
    messageThreadId: messageThreadId,
    lastMessageText: lastComment.text,
    lastMessageTimestampMs: lastComment.timestampMS
  };
};

export const getLastPartnerCommentItem = (
  commentListItems: CommentListItem[]
) => {
  const allComments = commentListItems.flatMap(item => item.comments);
  return allComments
    .filter(
      comment =>
        comment.memberType === CommentMemberType.COMMENT_MEMBER_TYPE_PARTNER
    )
    .pop();
};
